
<template>
  <div>
    <DialogTableExists :saving="loading.saving" :loading="loading.client" model="o cliente">
      <template slot="header">
        Cliente com este CPF/CPNJ já cadastrado
      </template>
      <template slot="content">
        <span class="subtitle-1 text-center">
          O cliente <span class="font-weight-bold">{{ attributes.name }}</span> com este mesmo CPF/CPNJ já esta cadastrado!
        </span>
        <span class="subtitle-1 text-center mb-6">
          Você pode incluir outros modúlos na edição dos dados do cliente.
        </span>
      </template>
      <template slot="info">
        <v-col cols="6" class="py-1 ma-0" v-if="attributes.name">Nome: <span class="font-weight-medium">{{ attributes.name }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="attributes.corporateName">Nome corporativo: <span class="font-weight-medium">{{ attributes.corporateName }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="attributes.CPF">CPF: <span class="font-weight-medium">{{ attributes.CPF }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="attributes.CNPJ">CNPJ: <span class="font-weight-medium">{{ attributes.CNPJ }}</span></v-col>
        <v-col cols="6" class="py-1 ma-0" v-if="attributes.main_address">Endereço: <span class="font-weight-medium">{{ attributes.main_address }}</span></v-col>
        <v-col cols="12" class="py-1 ma-0">
          <div class=" d-flex align-baseline ">
            <v-icon small >mdi-window-shutter-settings</v-icon> 
            <span class="ml-1 subtitle-2 font-weight-black">Cadastrado em:</span>
          </div>
          <v-list>
            <v-list-item v-for="depot in attributes.modalities" :key="depot.id">
              <v-list-item-icon><v-icon>mdi-circle-small</v-icon></v-list-item-icon>
              <v-list-item-title>{{depot.name}}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-col>
      </template>
      <template slot="actions">
        <v-spacer></v-spacer>
        <f-btn close @click="goBack"></f-btn>
        <f-btn save @click="openClientNewTab"  alt_text="Acessar dados do cliente" alt_icon="mdi-open-in-new"></f-btn>
      </template>
    </DialogTableExists>
  </div>
</template>

<script>
import Api from '@/api/index';
import { mapActions } from "vuex"
export default {
  name: 'ClientExist',
  components: {
    DialogTableExists: () => import("@/_backoffice/_registrations/components/shared/DialogTableExists.vue"),
  },
  data() {
    return {
      modality_id: null,
      client: { data: { attributes: { name:'' } }},
      loading:{
        client:false,
        saving:false,
      }
    }
  },
  methods: {
    getData() {
      this.getClient()
    },
    getClient() {
      this.loading.client = true
      Api.Client.show({id: this.client_id, clients_from_others_sellers: true}).then(req => req.data).then(data => {
        this.client = {...data}
      }).finally(()=>{
        this.loading.client = false
      })
    },
    openClientNewTab(){
      const routeData = this.$router.resolve({name: 'ShowClient', params: {id: this.client_id}});
      window.open(routeData.href, '_blank');
    },
    goBack(){
      this.$router.push({name:'CreateClient'})
    },

  },
  computed:{
    attributes(){
      return this.client?.data?.attributes
    },
    client_id(){
      return this.$route.params.id
    },
  },
  mounted() {
    this.getData()
  },
}
</script>